<template>
  <div>
    <v-container fluid>
      <v-card class="pa-2">
        <v-container fluid>
          <v-layout row wrap v-if="isLoading">
            <v-flex sm12>
              <div class="d-flex justify-center" >
                <v-progress-circular
                  indeterminate
                  class="ma-2"
                  color="primary"></v-progress-circular>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex lg7>
              <v-list dense>
                <v-list-item v-for="(value, key) in group" :key="`${group.key}-${key}`" v-if="key !== 'result'">
                  <v-list-item-content>{{ key | upper }}:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ value }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>
            <v-flex lg5 class="text-sm-right">
              <v-btn color="info" @click="goBackAction">
                <v-icon>arrow_back</v-icon>
                Back
              </v-btn>
              <v-btn color="error" class="ma-auto mr-2" @click="callDeleteMessagesDialog" :disabled="!selectedCount">
                <v-icon>delete</v-icon>
                Remove messages {{ selectedCount }}
              </v-btn>
              <v-btn color="error" class="ma-auto" @click="callDeleteGroupDialog">
                <v-icon>delete</v-icon>
                Remove group
              </v-btn>
            </v-flex>
            <v-flex md12>
              <v-data-table
                dense
                v-model="selected"
                :headers="headers"
                :items="group.result"
                :search="search"
                :options.sync="pagination"
                :rowsPerPageItems="rowsPerPageItems"
                show-expand
                show-select
                :expanded.sync="expanded"
                item-key="sid"
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div class="message-details">
                      <div class="message-details__option" :key="value" v-for="(value, key) in item" v-if="key !== 'sbody'">
                        <span class="message-details__option-key">{{ key | normalizeMessageKey }}:</span>
                        <span class="message-details__option-value">{{ value }}</span>
                      </div>
                      <div class="message-details__body" v-else>
                        <span class="message-details__body-key">{{ key | normalizeMessageKey }}:</span>
                        <span class="message-details__body-value">
                          <pre>{{ value }}</pre>
                        </span>
                      </div>
                    </div>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-container>
    <confirm-modal
      v-model="dialog"
      :title="messageTitle"
      @on-confirm="confirmDialogHandler"
      @on-cancel="cancelDialogHandler"
    ></confirm-modal>
  </div>
</template>


<script>
export default {
  data: () => ({
    search: '',
    dialog: false,
    isLoading: false,
    isGroupRemoving: false,
    selected: [],
    expanded: [],
    rowsPerPageItems: [10, 20, 40, 80 ,160, 300, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
    headers: [
      {
        text: 'ID:',
        sortable: true,
        value: 'sid'
      },
      {
        text: 'Date:',
        value: 'sdate'
      },
      {
        text: 'Subject:',
        value: 'ssubject'
      }
    ],
    group: {},
    pagination: {
      rowsPerPage: 40,
    },
  }),
  computed: {
    groupId() {
      return this.$route.params.id;
    },
    selectedCount() {
      return this.selected.length;
    },
    messageTitle() {
      return this.isGroupRemoving ? 'Remove group with all messages ?' : `Remove ${this.selectedCount} message(s)?`;
    }
  },
  filters: {
    normalizeMessageKey(value) {
      const key = value.slice(1);
      return key.charAt(0).toUpperCase() + key.slice(1);
    },
    upper(value) {
      return value.toUpperCase();
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.isLoading = true;

      // Response placeholder
      //
      // const mockMessage = {
      //   "key": "cpg.stratis.pro:51.210.151.175:stfargeau:prod03.stratis.pro:stfargeau:prod03.stratis.pro",
      //   "host": "cpg.stratis.pro(51.210.151.175)",
      //   "from": "stfargeau@prod03.stratis.pro",
      //   "to": "stfargeau@prod03.stratis.pro",
      //   "result": [
      //     {
      //       "sid": "11",
      //       "sdate": "2021-04-07 22:15:06.262718",
      //       "ssubject": "Cron &lt;stfargeau@prod03&gt; php ~/repository/vendor/bin/typo3cms scheduler:run -i 8",
      //       "sbody": "[Symfony\Component\Console\Exception\RuntimeException] The & quot; -i & quot;option does not exist.scheduler: run [--task TASK] [--force] [--task - id TASK - ID]"
      //     },
      //     {
      //       "sid": "19",
      //       "sdate": "2021-04-07 22:30:10.40584",
      //       "ssubject": "Cron &lt;stfargeau@prod03&gt; php ~/repository/vendor/bin/typo3cms scheduler:run -i 8",
      //       "sbody": "[Symfony\Component\Console\Exception\RuntimeException] The & quot; -i & quot; option does not exist.scheduler: run [--task TASK] [--force] [--task - id TASK - ID]"
      //     }
      //   ]
      // };

      const messageResponse = await this.$api.smtp.getGroup(this.groupId);
      const message = await messageResponse.data;

      this.group = message;
      this.isLoading = false;
    },
    clickRowHandler(props) {
      props.expanded = !props.expanded;
    },
    selectRowHandler(props) {
      props.selected = !props.selected;
    },
    callDeleteMessagesDialog() {
      this.isGroupRemoving = false;
      this.dialog = true;
    },
    callDeleteGroupDialog() {
      this.isGroupRemoving = true;
      this.dialog = true;
    },
    async confirmDialogHandler() {
      if (this.isGroupRemoving) {
        const response = await this.$api.smtp.deleteGroup(this.groupId);
        this.$router.push({ name: 'SmtpInput' });
      } else {
        if (this.selectedCount) {
          const messages = this.selected.map(item => item.sid);
          const response = await this.$api.smtp.deleteGroupMessages(messages);

          this.group.result = this.group.result.filter(item => {
            return !messages.some(id => id === item.sid);
          });

          this.selected = [];
        }
      }
    },
    cancelDialogHandler() {
      this.isGroupRemoving = false;
    },
    goBackAction() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
.message-details {
  padding: 20px 24px;
}

.message-details__body,
.message-details__option {
  display: flex;
  font-size: 14px;
  padding: 3px;
}

.message-details__body {
  flex-direction: column;
}

.message-details__option-key {
  margin-right: 20px;
  width: 80px;
}

.message-details__option-key,
.message-details__body-key {
  font-weight: bold;
}

.message-details__body-value,
.message-details__option-value {
  font-style: italic;
}

.message-details__body-value {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SmtpInput/message.vue